// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__357de","additionalInfo":"AgreementModal_additionalInfo__3b5w1"};